
import { useNavigate } from 'react-router-dom'
import RichText from '../RichText'
export const COLOR_REGEX = "%color%"

const AdvancedText = ({ texts, style, parseStyle, props, parseProps }) => {
    const navigate = useNavigate()

    return (
        <div style={style} {...props}>
            {typeof texts !== "string" &&
                <>{texts.map((value, idx) => {
                    function handleNavigate(route) {
                        if (route.action == "navigate")
                            //navigate(route.name, route.params)
                            window.open(route.name, '_blank')
                        else {
                             window.location = route.name
                          //  navigate(route.name, route.params)
                        }

                    }
                    if (typeof value === 'string') {
                        if (!value.includes(COLOR_REGEX)) return <RichText text={value}/>
                        else return (
                            <RichText {...parseProps} key={idx} text={value.trimStart().substring(COLOR_REGEX.length, value.length)}/>
                        )
                    }
                    else return (
                        <RichText {...value}
                            onClick={() => {
                                if (value.onPress) value.onPress()
                                else if (value.route) {
                                    handleNavigate(value.route)
                                }
                            }}
                            key={idx}
                            text={value.text}
                        />
                    )
                })}
                </>
            }
            {typeof texts === 'string' ? texts : ''}
        </div>
    )
}
export default AdvancedText;